<a
	href="{{href}}"
	target="_blank"
	rel="external noopener"
>
	{{yield}}
</a>
